import { useAuth } from "../../../../hooks/useAuth";
import useQueryApiClient from "../../../../utils/useQueryApiClient";

export function useProducts() {
  const { user } = useAuth()
  const farmId = user?.farmId;

  return useQueryApiClient({
    request: {
      url: '/api/v2/farms/' + farmId + '/coupons/products',
    }
  });
}